import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function RichTextEditor({ value, onChange }) {
  return (
    <ReactQuill
      value={value}
      onChange={onChange}
      theme="snow"
      style={{
        minHeight: '60vh',
        width: '100vw',
        background: 'transparent',
        borderRadius: 16,
        color: '#222',
        fontFamily: 'inherit',
        fontSize: '1.1rem',
        boxSizing: 'border-box'
      }}
      modules={{
        toolbar: [
          [{ 'header': [1, 2, 3, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ 'color': [] }, { 'background': [] }],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          ['link', 'image', 'video'],
          ['clean']
        ]
      }}
      formats={[
        'header', 'bold', 'italic', 'underline', 'strike', 'color', 'background',
        'list', 'bullet', 'link', 'image', 'video'
      ]}
    />
  );
}
